export const deleteAlert = async (id) => {
  // eslint-disable-next-line no-unused-vars
  const [match, csrf] = document.cookie.match(/csrf=([^;]*)/) || [];
  try {
    const response = await fetch(`/api/jobs/savedsearch/${id}`, {
      method: 'DELETE',
      headers: {
        'x-csrf-token': csrf,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw response;

    return 'success';
  } catch (err) {
    return 'error';
  }
};
